<template>
  <div class="center">
    <!-- 条件筛选框 -->
    <div class="waitingcom_title">
      <el-form
        :model="formLabelAlign"
        ref="formLabelAlign"
        label-width="80px"
        :label-position="labelPosition"
      >
        <el-form-item label="考试名称：">
          <el-input
            v-model.trim="formLabelAlign.examName"
            placeholder="请输入考试名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="组卷模式：">
          <el-select v-model="formLabelAlign.examModel" @change="handleQuery">
            <el-option
              v-for="item in examModelArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="考试状态：">
          <el-select v-model="formLabelAlign.examStatus" @change="handleQuery">
            <el-option
              v-for="item in examStatusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间：">
          <el-date-picker
            v-model="formLabelAlign.examTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="创建开始日期"
            end-placeholder="创建结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <!-- 搜索按钮 -->
      <div class="query_btn">
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetQuery"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
      </div>
    </div>

    <!-- 表格内容 -->
    <div class="monitor_table" v-loading="isLoading">
      <el-table
        ref="table"
        :data="getData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="考试名称" align="center" width="150"
          ><template slot-scope="scope">
            <span>{{ scope.row.ExamName }}</span>
            <el-tooltip placement="right-start" effect="darkts">
              <div slot="content" class="bubbles_box">
                <div
                  class="bubbles_son"
                  style="color: #ffffff; background-color: #00d254"
                >
                  <p>总分:{{ scope.row.TotalScore }}分</p>
                  <p>时间:{{ scope.row.SpendTime }}分钟</p>
                </div>

                <br />
                <div
                  class="bubbles_son"
                  style="color: #ffffff; background-color: #00d254"
                >
                  <p>参考人员:{{ scope.row.StudentCount }}人</p>
                  <p>及格线:{{ scope.row.PassScore }}分</p>
                </div>
              </div>
              <i class="iconfont icon-tishi"></i>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column label="组卷模式" align="center"
          ><template slot-scope="scope">
            <span>{{ scope.row.PaperMode | pageModels("PaperModeExam") }}</span>
          </template>
        </el-table-column>

        <el-table-column label="命题方式" align="center"
          ><template slot-scope="scope">
            <span>{{ scope.row.PaperMode | pageModels("PaperModeName") }}</span>
          </template>
        </el-table-column>

        <el-table-column label="考试时间" align="center" width="270px"
          ><template slot-scope="scope">
            <span>{{
              scope.row.BeginTime != null && scope.row.EndTime != null
                ? $moment(scope.row.BeginTime).format("YYYY/MM/DD HH:mm") +
                  "-" +
                  $moment(scope.row.EndTime).format("YYYY/MM/DD HH:mm")
                : null
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="考试状态" align="center" width="100px"
          ><template slot-scope="scope">
            <span
              v-if="
                scope.row.IsPublish === 1 &&
                scope.row.BeginTime > scope.row.ServerTime
              "
              style="color: #00d254"
              >● 待考试</span
            >
            <span
              v-if="
                scope.row.IsPublish === 1 &&
                scope.row.BeginTime <= scope.row.ServerTime &&
                scope.row.ServerTime < scope.row.EndTime
              "
              style="color: #ffa200"
              >● 考试中</span
            >
            <span
              v-if="
                scope.row.IsPublish === 1 &&
                scope.row.ServerTime > scope.row.EndTime
              "
              style="color: #ff0000"
              >● 考试结束</span
            >
          </template>
        </el-table-column>

        <el-table-column label="应考人数" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.StudentCount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="正在考试" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.onlineCount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="已考人数" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.AlreadyStuCount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="未参加考试" align="center" width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.StudentCount -
              scope.row.AlreadyStuCount -
              scope.row.onlineCount
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="130">
          <template slot-scope="scope">
            <span>{{
              $moment(scope.row.CreateTime).format("YYYY/MM/DD HH:mm")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="组卷人" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.UserName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                @click="examInquiry(scope.row)"
                type="text"
                size="small"
                >考试查询</el-button
              >
              <el-button
                v-if="
                  scope.row.IsPublish === 1 &&
                  scope.row.BeginTime <= scope.row.ServerTime
                "
                @click="getExamWinding(scope.row)"
                type="text"
                size="small"
                >提前收卷</el-button
              >
              <el-button
                v-if="
                  scope.row.IsPublish === 1 &&
                  scope.row.BeginTime <= scope.row.ServerTime &&
                  scope.row.ServerTime < scope.row.EndTime &&
                  scope.row.PaperMode.indexOf('random_') == -1
                "
                @click="sendExamStudent(scope.row)"
                type="text"
                size="small"
                >添加考生</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="total"
          class="pagination"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
import monitorApi from "@/api/monitor";
export default {
  props: ["changes"],
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      // 条件筛选框全局定义
      labelPosition: "right",
      formLabelAlign: {
        examName: "",
        examModel: "",
        examStatus: "",
        cc: "",
      },
      examModelArr: [
        {
          label: "全部",
        },
        {
          value: "unified_db",
          label: "智能组卷",
        },
        {
          value: "unified_exam",
          label: "试卷组卷",
        },
        {
          value: "sg_db",
          label: "精准组卷",
        },
        {
          value: "unified_Proportion",
          label: "权重组卷",
        },
      ],
      examStatusArr: [
        {
          label: "全部",
        },
        {
          value: "0",
          label: "待考试",
        },
        {
          value: "1",
          label: "考试中",
        },
        {
          value: "2",
          label: "考试结束",
        },
      ],
      // 表格内容全局定义
      isLoading: true,
      multipleSelectionIds: [],
      multipleSelection: [],
      multipleSelectionCount: 0,
      getDataCondition: {
        examName: "",
        examModel: "",
        examStatus: "",
        createBeginTime: "",
        createEndTime: "",
      },
      getData: [],
      currentPage: 1,
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
      rowData: {},
    };
  },
  methods: {
    // 条件筛选框
    handleQuery() {
      this.Buriedpoint(
        {
          code: "OnlineTest:Monitoring:search",
          parent_code: "OnlineTest:Monitoring",
        },
        "statetime"
      );
      this.currentPage = 1;
      this.isLoading = true;
      if (this.formLabelAlign.examName) {
        this.getDataCondition.examName = this.formLabelAlign.examName;
      } else {
        this.getDataCondition.examName = "";
      }
      if (this.formLabelAlign.examModel) {
        this.getDataCondition.examModel = this.formLabelAlign.examModel;
      } else {
        this.getDataCondition.examModel = "";
      }
      if (this.formLabelAlign.examStatus) {
        this.getDataCondition.examStatus = this.formLabelAlign.examStatus;
      } else {
        this.getDataCondition.examStatus = "";
      }
      if (
        this.formLabelAlign.examTime &&
        this.formLabelAlign.examTime.length == 2
      ) {
        this.getDataCondition.createBeginTime = this.$moment(
          this.formLabelAlign.examTime[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        this.getDataCondition.createEndTime = this.$moment(
          this.formLabelAlign.examTime[1]
        ).format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.getDataCondition.createBeginTime = "";
        this.getDataCondition.createEndTime = "";
      }
      this.getexamLists();
    },
    // 重置
    resetQuery() {
      this.Buriedpoint(
        {
          code: "OnlineTest:Monitoring:rest",
          parent_code: "OnlineTest:Monitoring",
        },
        "statetime"
      );
      this.formLabelAlign = {};
      this.currentPage = 1;
      this.isLoading = true;
      this.getDataCondition.examName = "";
      this.getDataCondition.examModel = "";
      this.getDataCondition.examStatus = "";
      this.getDataCondition.createBeginTime = "";
      this.getDataCondition.createEndTime = "";
      this.getexamLists();
    },
    // 基本请求参数工具
    baseReqParamUtils(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    // 获取试卷列表
    async getexamLists() {
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.pageIndex = this.currentPage - 1;
      reqParam.eachPageNum = this.pageSize;
      reqParam.type = 0;
      reqParam.operatUserID = "";

      reqParam.examName = this.getDataCondition.examName;
      reqParam.examModel = this.getDataCondition.examModel;
      reqParam.examStatus = this.getDataCondition.examStatus;
      reqParam.createBeginTime = this.getDataCondition.createBeginTime;
      reqParam.createEndTime = this.getDataCondition.createEndTime;

      // console.log(reqParam, "获取试卷列表请求数据");
      const { data } = await monitorApi.getexamList(reqParam);
      // console.log(data, "获取试卷列表响应数据");
      if (data.Status == 200) {
        this.getData = data.Data.data;
        this.total = data.Data.count;
        this.isLoading = false;
      } else {
        this.$message.error(data.Data);
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 表格多选框改变时触发
    handleSelectionChange(rows) {
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      // 将数据存入
      rows.forEach((row) => {
        this.multipleSelectionIds.push(row.NoticeID);
      });
      this.multipleSelection = rows;
      this.multipleSelectionCount = this.multipleSelection.length;
      // 全局按钮样式配置
      this.multiple = !this.multipleSelection.length;
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.NoticeID;
    },
    // 每页大小改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.isLoading = true;
      this.getexamLists();
    },
    // 切换页数后触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.isLoading = true;
      this.getexamLists();
    },
    // 考试查询
    examInquiry(row) {
      this.$parent.rowObj = row;
      localStorage.setItem("isreload", true);
      this.Buriedpoint({
        code: "OnlineTest:Monitoring:testQuery",
        parent_code: "OnlineTest:Monitoring",
      });
      this.rowData = row;
      this.changes(1);
    },
    getExamWinding: function (row) {
      this.rowData = row;
      this.changes(2);
    },
    sendExamStudent: function (row) {
      this.rowData = row;
      this.changes(3);
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
  },
  filters: {
    pageModels(PaperMode, key) {
      switch (PaperMode) {
        case "unified_db":
          if (key === "PaperModeName") {
            return "统一命题";
          } else if (key === "PaperModeExam") {
            return "智能组卷";
          }
          break;
        case "random_db":
          if (key === "PaperModeName") {
            return "随机命题";
          } else if (key === "PaperModeExam") {
            return "智能组卷";
          }
          break;
        case "unified_exam":
          if (key === "PaperModeName") {
            return "统一命题";
          } else if (key === "PaperModeExam") {
            return "试卷组卷";
          }
          break;
        case "random_exam":
          if (key === "PaperModeName") {
            return "随机命题";
          } else if (key === "PaperModeExam") {
            return "试卷组卷";
          }
          break;
        case "unified_Proportion":
          if (key === "PaperModeName") {
            return "统一命题";
          } else if (key === "PaperModeExam") {
            return "权重组卷";
          }
          break;
        case "random_Proportion":
          if (key === "PaperModeName") {
            return "随机命题";
          } else if (key === "PaperModeExam") {
            return "权重组卷";
          }
          break;
        case "sg_db":
          if (key === "PaperModeName") {
            return "手动命题";
          } else if (key === "PaperModeExam") {
            return "精准组卷";
          }
          break;
        case "unified_difflever":
          if (key === "PaperModeName") {
            return "统一命题";
          } else if (key === "PaperModeExam") {
            return "难易度组卷";
          }
          break;
        case "random_difflever":
          if (key === "PaperModeName") {
            return "随机命题";
          } else if (key === "PaperModeExam") {
            return "难易度组卷";
          }
          break;
        case "paper":
          if (key === "PaperModeExam") {
            return "纸质试卷";
          }
          break;

        default:
          break;
      }
    },
  },
  created() {
    this.stateArr = [];
    this.getexamLists();
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 115px !important;
    }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}

// 表格内容css
.monitor_table {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
}

.operation_box {
  text-align: center;
  margin: 0 auto;
  .el-button {
    font-size: 16px;
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}

::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}

.bubbles_box {
  .bubbles_son {
    display: flex !important;
    p {
      flex: 1;
      width: 80px;
    }
  }
}

.icon-tishi {
  display: inline-block;
  transform: translate(-1px, -3px) scale(0.6);
  &::before {
    color: #cad8d0;
    display: inline-block;
  }
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
  .foot_pagetions {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
    .pagination {
      ::v-deep .el-pager {
        li {
          border: 1px solid #d9d9d9;
          margin-right: 8px;
          &.active {
            color: #ffffff;
            background-color: #409eff;
            border: none;
          }
        }
      }
      ::v-deep .el-pagination__jump {
        margin: 0px 10px 0px 0px !important;
      }
      // ::v-deep .el-pagination__jump {
      //   &::before {
      //     content: "10条/页";
      //     width: 82px;
      //     border: 1px solid #d9d9d9;
      //     height: 28px;
      //     border-radius: 2px;
      //     text-align: center;
      //     display: inline-block;
      //     margin-right: 8px;
      //     cursor: pointer;
      //   }
      // }
    }
  }
}
</style>

<style lang="scss">
.el-tooltip__popper.is-darkts {
  background: #00d254;
  > :nth-child(2) {
    border-right: 6px solid #00d254 !important;
    &::after {
      border: none;
    }
  }
}
</style>
